<template>
  <ul class="k4-menu">
    <li v-if="condition" name="GeneralDashboard" @click="goToPage('GeneralDashboard')" class="k4-menu__item my-1 mx-3" role="button" :class="{ 'k4-menu__item--isActive': this.$route.name == 'GeneralDashboard' }">
      <span class="px-2 d-flex align-items-center">
        <Icon class="ico" size="20" type="md-analytics"></Icon> 
        <div class="px-1 text-wrap">Dashboard</div>
      </span>
    </li>
    <li v-if="condition" name="LeadsProcessed" @click="goToPage('LeadsProcessed')" class="k4-menu__item my-1 mx-3" role="button" :class="{ 'k4-menu__item--isActive': this.$route.name == 'LeadsProcessed' }">
      <span class="px-2 d-flex align-items-center">
        <Icon class="ico" size="20" type="md-barcode"></Icon> 
        <div class="px-1 text-wrap">Leads Processed</div>
      </span>
    </li>
    <li v-if="condition" name="ExportData" @click="goToPage('ExportData')" v-show="getAdminUser" class="k4-menu__item my-1 mx-3" role="button" :class="{ 'k4-menu__item--isActive': this.$route.name == 'ExportData' }">
      <span class="px-2 d-flex align-items-center">
        <Icon class="ico" size="20" type="md-download"></Icon> 
        <div class="px-1 text-wrap">Export to Excel</div>
      </span>
    </li>
    <li v-if="condition" name="MyLeadForms" @click="goToPage('MyLeadForms')" v-show="getAdminUser" class="k4-menu__item my-1 mx-3" role="button" :class="{ 'k4-menu__item--isActive': this.$route.name == 'MyLeadForms' }">
      <span class="px-2 d-flex align-items-center">
        <Icon class="ico" size="20" type="md-contacts"></Icon> 
        <div class="px-1 text-wrap">Contact Form Settings</div>
      </span>
    </li>
    <li v-show="condition" name="MyQuestionnaireForms" @click="goToPage('MyQuestionnaireForms')" class="k4-menu__item my-1 mx-3" role="button" :class="{ 'k4-menu__item--isActive': this.$route.name == 'MyQuestionnaireForms' }">
      <span class="px-2 d-flex align-items-center">
        <Icon class="ico" size="20" type="md-list-box"></Icon>
        <div class="px-1 text-wrap">Customized Forms Settings</div>
      </span>
    </li>
    <li v-show="getAdminUser" name="GlobalAdministration" @click="goToPage('GlobalAdministration')" class="k4-menu__item my-1 mx-3" role="button" :class="{ 'k4-menu__item--isActive': this.$route.name == 'GlobalAdministration' }">
      <span class="px-2 d-flex align-items-center">
        <Icon class="ico" size="20" type="md-cog"></Icon> 
        <div class="px-1 text-wrap">Global Administration</div>
      </span>
    </li>
  </ul>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import {bus} from '../main'

  export default {
    data() {
      return {
        role: localStorage.getItem('role'),
        eventName: localStorage.getItem('selected_event'),
        companyName: localStorage.getItem('selected_company'),
        showForms: true
      }
    },
    computed: {
      ...mapGetters(['getUserDetails', 'getAdminUser']),
      ...mapGetters(['getEvent', 'getEventList']),
      ...mapGetters(['getCompanyDetail', 'getCompanyListDetail']),
      ...mapGetters(['getLicenseDetail', 'getLicenseListDetail']),
      condition() {
        this.eventName = localStorage.getItem('selected_event');
        this.companyName = localStorage.getItem('selected_company');
        if (this.role === 'admin') {
          if (this.eventName != 0 && this.companyName != 0) {
            return true;
          } else return false;
        } else return true;
      }
    },
    methods: {
      ...mapActions(['setUserDetails', 'setAdminUser']),
      ...mapActions(['setEvent', 'setEventList']),
      ...mapActions(['setCompanyDetail', 'setCompanyListDetail']),
      ...mapActions(['setLicenseDetail', 'setLicenseListDetail']),

      goToPage(route) {
        let role = localStorage.getItem('role');
        if (role === 'admin') {
          this.$router.push({name: route});
        } 
        else {
          let selectedEvent = localStorage.getItem('selected_event');
          if (selectedEvent && selectedEvent != 0) {
            this.$router.push({name: route});
          } 
          else {
            this.$Message.error({
              content: 'Please Select an Event...', duration: 3, top: 50, closable: true
            });
            this.$router.push({name: 'GeneralDashboard'});
          }
        }
      }
    },
    mounted() {
      bus.$on('getActiveLink', (route) => {
        this.goToPage(route)
      });
      bus.$on('getEvtName', (eventName) => {
        sessionStorage.setItem('eventName', eventName);
        this.eventName = eventName;
      });
      bus.$on('getCmpName', (companyName) => {
        sessionStorage.setItem('companyName', companyName);
        this.companyName = companyName;
      });
      if (localStorage.getItem('role') !== 'admin') {
        this.showForms = false;
      }
      this.condition;
    }
  }
</script>

<style scoped>
  .k4-menu {
    width: auto;
    font-size: 0.85em;
  }
  .k4-menu__item {
    display: flex;
    align-items: center;
    height: 3em;
    background-color: var(--white);
    color: var(--primary-dark);
    border-radius: 5px;
    animation-delay: 2s;
  }

  .k4-menu__item:hover {
    color: var(--success);
  }

  .k4-menu__item--isActive {
    background-color: var(--success) !important;
    color: var(--white) !important;
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue